import { StackPanel } from '@agilepoint/wat-react-ux';
import { IAnnouncementParam } from 'modules/shared/queries';
import { FormProvider, useForm } from 'react-hook-form';
import { CreateAnnouncementForm } from './create-announcement-form';

interface ICreateAccouncementProps {
    saveAnnouncementInfo: (formData: IAnnouncementParam) => Promise<any>;
    removePopup?: (id: string) => void;
    popupId: string;
    announcementData?: IAnnouncementParam;
}

export function CreateAccouncement(props: ICreateAccouncementProps) {
    const methods = useForm({
        mode: 'onBlur',
        defaultValues: props.announcementData || {}
    });
    return (
        <StackPanel width='100%' height='100%' orientation='vertical' justifyContent='center' alignment='center'>
            <FormProvider {...methods}>
                <CreateAnnouncementForm {...props} />
            </FormProvider>
        </StackPanel>
    );
}
